import { createSelector } from 'reselect';
import { dayjs } from 'utils/date';

import { getStateAtNamespaceKey } from 'redux/get-state-at-namespace-key';
import { getActiveAddresses } from 'redux/modules/address/selectors/get-address-selectors';
import { getCustomerEmail } from 'redux/modules/accounts/selectors/get-customer-account';

import urls from 'constants/urls';

export const getMyWaitrose = (state: WtrState) => getStateAtNamespaceKey(state, 'myWaitrose');

export const getMyWaitroseRequest = createSelector(getMyWaitrose, myWaitrose => myWaitrose.request);

export const getMyWaitroseIsLoading = createSelector(
  getMyWaitroseRequest,
  request => request.isLoading,
);

export const getMyWaitroseIsLoaded = createSelector(
  getMyWaitroseRequest,
  request => request.isLoading === false,
);

export const getMyWaitroseRequestError = createSelector(
  getMyWaitroseRequest,
  request => request.error ?? null,
);

export const getMyWaitroseCardNumber = createSelector(
  getMyWaitrose,
  myWaitrose => myWaitrose.cardNumber,
);

export const getLeftMyWaitrose = createSelector(
  getMyWaitrose,
  myWaitrose => myWaitrose.leftMyWaitrose,
);

export const replacementCardFormSubmit = (state: WtrState) => {
  // @ts-expect-error At the time we converted this file to typescript, form was not part of WtrState yet. This comment can be removed once for gets added to WtrState
  const { formSubmitted = false } = state.form.MyWaitroseCardReplacement || {};

  return formSubmitted;
};

export const replacementCardLinkLocation = (state: WtrState) => {
  if (
    !!getActiveAddresses(state).length &&
    !!getCustomerEmail(state) &&
    !!getMyWaitroseCardNumber(state)
  ) {
    return urls.orderReplacementCard;
  }

  return urls.replaceMyWaitroseCard;
};

export const userCanRequestPhysicalMyWaitroseCard = createSelector(getMyWaitrose, myWaitrose =>
  dayjs(myWaitrose.modified).add(48, 'hour').isBefore(dayjs()),
);
